import Wrapper from 'components/Wrapper';
export default Wrapper;
